import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Card, Typography, Grid } from '@material-ui/core';
import moment from 'moment';

const Total = props => {
  const { className, ...rest } = props;
  const currency = '฿';
  const classes = useStyles();
  const billing = useSelector(({ billing }) => billing.data);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        alignItems="center"
        container
        justify="space-between"
      >
        {billing && (
                    <>
                        <Grid
                          className={classes.item}
                          item
                          lg={4}
                          sm={4}
                          xs={12}
                        >
                          <div className={classes.valueContainer}>
                            <Typography
                              className={classes.number}
                              variant="h3"
                            >
                                    Total Fee
                            </Typography>
                          </div>
                        </Grid>
                        <Grid
                          className={classes.item}
                          item
                          lg={4}
                          sm={4}
                          xs={12}
                        >
                          <Typography
                            className={classes.number}
                            variant="h3"
                          >{`${currency}${billing.current.amount}`}</Typography>
                        </Grid>
                        <Grid
                          className={classes.item}
                          item
                          lg={4}
                          sm={4}
                          xs={12}
                        >
                          <Typography
                            className={classes.number}
                            variant="h3"
                          >
                            {moment(billing.current.date).format('DD/MM/YYYY')}
                          </Typography>
                        </Grid>
                    </>
        )}
      </Grid>
    </Card>
  );
};

Total.propTypes = {
  className: PropTypes.string
};

export default Total;

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  item: {
    padding: theme.spacing(3),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      '&:not(:last-of-type)': {
        // borderRight: `1px solid ${theme.palette.divider}`
      }
    },
    [theme.breakpoints.down('sm')]: {
      '&:not(:last-of-type)': {
        // borderBottom: `1px solid ${theme.palette.divider}`
      }
    }
  },
  valueContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  number: {
    color: '#304ffe'
  }
}));
